<template lang="pug">
//div
dropdown-key-value(:options="vtOptions" v-on="$listeners" v-bind="$attrs" :placeholder="$t('Выберите способ подтверждения')")
  //v-on="$listeners"
  //unknown-dropdown-key-value(:options="vtOptions" v-on="$listeners" v-bind="$attrs" :placeholder="$t('Выберите способ подтверждения')")
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DropdownKeyValue from '@/components/forms/dropdown/DropdownKeyValue.vue';

import { VerificationTypes } from '@/models/verification/verification';
//import UnknownDropdownKeyValue from "@/components/forms/other/UnknownDropdownKeyValue.vue";

@Component({
  name: 'SelectVerificationType',
  inheritAttrs: false,
  components: { DropdownKeyValue },
})
export default class SelectVerificationType extends Vue {
  @Prop({ default: () => [] })
  visibleOptions!: VerificationTypes[]


  get vtOptions(): any {
    const result = {};

    for (const v of this.visibleOptions) result[v] = this.$t(`verification.type.${v}`);
    return result;
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "verification": {
      "type": {
        "OTP": "SMS confirmation",
        "SIGNATURE": "Certificate",
        "TABLECODE": "Code table",
        "NONE": "Without verification",
        "CODE": "By email",
        "PIN": "Payment PIN",
        "GOOGLECODE": "Google 2FA"
      }
    },
    "Выберите способ подтверждения": "Select verification type"
  },
  "ru": {
    "verification": {
      "type": {
        "OTP": "SMS подтверждение",
        "SIGNATURE": "Сертификат",
        "TABLECODE": "Таблица кодов",
        "NONE": "Без верификации",
        "CODE": "По электронной почте",
        "PIN": "Платежный PIN-код",
        "GOOGLECODE": "Google 2FA"
      }
    }
  }
}
</i18n>
